'use client'

export type HomeSearchPrefillDetail = {
    from?: { code: string; display?: string }
    to?: { code: string; display?: string }
}

type PrefillOptions = {
    /**
     * Invoked when both from and to codes exist in the href.
     * Return true if you handled navigation yourself.
     */
    onBothParams?: (from: string, to: string, origin?: string, destination?: string) => void | Promise<void>
}

export const useHomeSearchPrefill = (options?: PrefillOptions) => {
    const handlePrefillFromHref = (href: string): boolean => {
        try {
            const url = new URL(href, 'https://www.flyin.com')
            const searchParams = url.searchParams
            const from = searchParams.get('from') || ''
            const to = searchParams.get('to') || ''
            const origin = searchParams.get('origin') || ''
            const destination = searchParams.get('destination') || ''

            const hasFrom = Boolean(from)
            const hasTo = Boolean(to)

            // If both are present, delegate to provided callback (Book Now flow)
            if (hasFrom && hasTo) {
                options?.onBothParams?.(from, to, origin, destination)
                return true
            }

            // Only handle cases where exactly one of from/to exists
            if (!hasFrom && !hasTo) return false

            const detail: HomeSearchPrefillDetail = {}
            if (hasFrom) {
                detail.from = { code: from, display: origin ? decodeURIComponent(origin) : from }
            }
            if (hasTo) {
                detail.to = { code: to, display: destination ? decodeURIComponent(destination) : to }
            }

            window.dispatchEvent(new CustomEvent<HomeSearchPrefillDetail>('home-search-prefill', { detail }))
            return true
        } catch (error) {
            console.error('Error handling prefill navigation:', error)
            return false
        }
    }

    return { handlePrefillFromHref }
}
